// extracted by mini-css-extract-plugin
var _1 = "etnWg";
export { _1 as "base" }
